<div class="container">
    <div class="section-title">
        <h2>Erfahrungen unserer Fahrschüler</h2>
        <div class="bar"></div>
        <p>Das sagen unsere ehemaligen Schüler über ihre Ausbildung bei Tommys Fahrschule. Persönlich, erfolgreich und mit Spaß zum Führerschein!</p>
    </div>

    <div class="testimonials-slides">
        <div class="client-feedback">
            <div>
                <div class="item">
                    <div class="single-feedback">
                        <div class="icon">
                            <i class="fa fa-quote-left"></i>
                        </div>
                        <p>“Top Fahrschule! Theorie in einer Woche durchgezogen und keine Wartezeit auf Fahrstunden. Ich hab mich super aufgehoben gefühlt.”</p>
                    </div>
                </div>

                <div class="item">
                    <div class="single-feedback">
                        <div class="icon">
                            <i class="fa fa-quote-left"></i>
                        </div>
                        <p>“Thomas und sein Team sind einfach klasse! Geduldig, ehrlich und immer gut gelaunt. Ich habe mich auf jede Fahrstunde gefreut.”</p>
                    </div>
                </div>

                <div class="item">
                    <div class="single-feedback">
                        <div class="icon">
                            <i class="fa fa-quote-left"></i>
                        </div>
                        <p>“Moderne Autos, cooles Team und sehr faire Preise. Ich kann Tommys Fahrschule nur jedem empfehlen!”</p>
                    </div>
                </div>

                <div class="item">
                    <div class="single-feedback">
                        <div class="icon">
                            <i class="fa fa-quote-left"></i>
                        </div>
                        <p>“Besonders die Flexibilität bei den Fahrstunden war für mich super. Ich konnte alles perfekt mit Uni und Job abstimmen.”</p>
                    </div>
                </div>

                <div class="item">
                    <div class="single-feedback">
                        <div class="icon">
                            <i class="fa fa-quote-left"></i>
                        </div>
                        <p>“Ich habe beim ersten Versuch bestanden – dank der tollen Vorbereitung! Man fühlt sich hier nicht wie eine Nummer, sondern ernst genommen.”</p>
                    </div>
                </div>

                <div class="item">
                    <div class="single-feedback">
                        <div class="icon">
                            <i class="fa fa-quote-left"></i>
                        </div>
                        <p>“Nuhat war der beste Fahrlehrer, den man sich wünschen kann – ruhig, freundlich und sehr kompetent. Danke für alles!”</p>
                    </div>
                </div>

                <div class="item">
                    <div class="single-feedback">
                        <div class="icon">
                            <i class="fa fa-quote-left"></i>
                        </div>
                        <p>“Ich hatte große Prüfungsangst, aber Behzad hat mir Schritt für Schritt geholfen, sicher zu werden. Jetzt liebe ich Autofahren!”</p>
                    </div>
                </div>

                <div class="item">
                    <div class="single-feedback">
                        <div class="icon">
                            <i class="fa fa-quote-left"></i>
                        </div>
                        <p>“Lars war immer pünktlich, hilfsbereit und hat mir genau erklärt, worauf es ankommt. Super sympathisch!”</p>
                    </div>
                </div>
            </div>

            <button class="prev-arrow slick-arrow">
                <i class="fa fa-chevron-left"></i>
            </button>

            <button class="next-arrow slick-arrow">
                <i class="fa fa-chevron-right"></i>
            </button>
        </div>

        <div class="client-thumbnails">
            <div>
                <div class="item">
                    <div class="title">
                        <h3>Lisa Mertens</h3>
                        <span>Studentin</span>
                    </div>
                </div>

                <div class="item">
                    <div class="title">
                        <h3>Kevin Schuster</h3>
                        <span>Azubi</span>
                    </div>
                </div>

                <div class="item">
                    <div class="title">
                        <h3>Selina Baum</h3>
                        <span>Schülerin</span>
                    </div>
                </div>

                <div class="item">
                    <div class="title">
                        <h3>Ahmet Yilmaz</h3>
                        <span>Werkstudent</span>
                    </div>
                </div>

                <div class="item">
                    <div class="title">
                        <h3>Julia König</h3>
                        <span>Erzieherin</span>
                    </div>
                </div>

                <div class="item">
                    <div class="title">
                        <h3>Marco Fuchs</h3>
                        <span>Student</span>
                    </div>
                </div>

                <div class="item">
                    <div class="title">
                        <h3>Mina Albrecht</h3>
                        <span>Auszubildende</span>
                    </div>
                </div>

                <div class="item">
                    <div class="title">
                        <h3>Leon Schneider</h3>
                        <span>Teilzeitkraft</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
